import classNames from 'clsx';
import { ComponentProps, FC, createElement, forwardRef } from 'react';

export type Tag = keyof JSX.IntrinsicElements;
export type IAttr<T extends Tag> = Omit<JSX.IntrinsicElements[T], keyof JSX.IntrinsicClassAttributes<unknown>>;

export function intrinsicClassName<R extends HTMLElement, T extends Tag>(
  Component: T,
  baseClassName: string
): FC<ComponentProps<T> & { ref?: React.RefObject<R> }> {
  // TS optimization: forwardRef<unknown, { className?: string }>
  return forwardRef<R, { className?: string }>(function WithClassName({ className, ...rest }, ref) {
    return createElement(Component, {
      className: classNames(baseClassName, className),
      ref,
      ...rest,
    });
  }) as unknown as any;
}
